export default "__VITE_ASSET__DmcO080d__"